import axios from 'axios'
import React, { useEffect } from 'react'
import { FaAccusoft, FaAdn, FaCheckCircle, FaUsers, FaWindowClose } from 'react-icons/fa'
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import { styled, useTheme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'Auto',
    color: theme.palette.text.secondary,
}));

const TopCard = ({privates, govt, business, professional, all, newStatus, followedStatus, ContactMadeStatus }) => {

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                <Grid style={{ height: '8rem', marginBottom: '0.8rem', }} item xs={4}>
                    <div className='topCard'>
                        <Item elevation={0} sx={{ height: '6.7rem', position: 'relative' }}>
                            <Typography style={{ marginBottom: 3 }}>Session</Typography>
                            <div style={{ position: 'absolute', right: '0.8rem', top: '0.7rem', padding: '0.4rem', borderRadius: '0.3rem', backgroundColor: 'rgb(213, 208, 246)' }}>
                                <GroupOutlinedIcon style={{ position: 'relative', color: 'rgb(126, 110, 228)' }}   > </GroupOutlinedIcon>
                            </div>
                            <Typography color='green'>{all}</Typography>
                            <br />
                            <Typography>All lead management users</Typography>
                        </Item>
                    </div>
                </Grid>
                <Grid style={{ height: '8rem', marginBottom: '0.8rem' }} item xs={2}>
                    <div className='topCard'>
                        <Item elevation={0} sx={{ height: '6.7rem', position: 'relative' }}>
                            <Typography style={{ marginBottom: 3 }}>Business</Typography>
                            <div style={{ position: 'absolute', right: '0.8rem', top: '0.7rem', padding: '0.4rem', borderRadius: '0.3rem', backgroundColor: 'rgb(213, 208, 246)' }}>
                                <GroupOutlinedIcon style={{ position: 'relative', color: 'rgb(126, 110, 228)' }}   > </GroupOutlinedIcon>
                            </div>
                            <Typography color='green'>{business}</Typography>
                            <br />
                            <Typography style={{ fontSize: 11 }}>All Business Employment</Typography>
                        </Item>
                    </div>
                </Grid>
                <Grid style={{ height: '8rem', marginBottom: '0.8rem' }} item xs={2}>
                    <div className='topCard'>
                        <Item elevation={0} sx={{ height: '6.7rem', position: 'relative' }}>
                            <Typography style={{ marginBottom: 3 }}>Govt Job</Typography>
                            <div style={{ position: 'absolute', right: '0.8rem', top: '0.7rem', padding: '0.4rem', borderRadius: '0.3rem', backgroundColor: 'rgb(213, 208, 246)' }}>
                                <GroupOutlinedIcon style={{ position: 'relative', color: 'rgb(126, 110, 228)' }}   > </GroupOutlinedIcon>
                            </div>
                            <Typography color='green'>{govt}</Typography>
                            <br />
                            <Typography style={{ fontSize: 11 }}>Govt Jobs Employment</Typography>
                        </Item>
                    </div>
                </Grid>
                <Grid style={{ height: '8rem', marginBottom: '0.8rem' }} item xs={2}>
                    <div className='topCard'>
                        <Item elevation={0} sx={{ height: '6.7rem', position: 'relative' }}>
                            <Typography style={{ marginBottom: 3 }}>Private Job</Typography>
                            <div style={{ position: 'absolute', right: '0.8rem', top: '0.7rem', padding: '0.4rem', borderRadius: '0.3rem', backgroundColor: 'rgb(213, 208, 246)' }}>
                                <GroupOutlinedIcon style={{ position: 'relative', color: 'rgb(126, 110, 228)' }}   > </GroupOutlinedIcon>
                            </div>
                            <Typography color='green'>{privates}</Typography>
                            <br />
                            <Typography style={{ fontSize: 11 }}>Private Jobs Employment</Typography>
                        </Item>
                    </div>
                </Grid>
                <Grid style={{ height: '8rem', marginBottom: '0.8rem' }} item xs={2}>
                    <div className='topCard'>
                        <Item elevation={0} sx={{ height: '6.7rem', position: 'relative' }}>
                            <Typography style={{ marginBottom: 3 }}>Professional</Typography>
                            <div style={{ position: 'absolute', right: '0.8rem', top: '0.7rem', padding: '0.4rem', borderRadius: '0.3rem', backgroundColor: 'rgb(213, 208, 246)' }}>
                                <GroupOutlinedIcon style={{ position: 'relative', color: 'rgb(126, 110, 228)' }}   > </GroupOutlinedIcon>
                            </div>
                            <Typography color='green'>{professional}</Typography>
                            <br />
                            <Typography style={{ fontSize: 11 }}>Professionals Employment</Typography>
                        </Item>
                    </div>
                </Grid>
            </Grid>
            {/* <Grid container spacing={2}>
                <Grid style={{ height: '10rem', marginBottom: '0.8rem' }} item xs={12}>
                    <div className='topCard'>
                        <Item elevation={0} sx={{ height: '8.6rem', position: 'relative' }}>
                            <Typography style={{ marginBottom: 3 }}>Lead Status</Typography>
                            <Grid container spacing={2}>
                                <Grid style={{ height: '8rem', marginBottom: '0.8rem' }} item xs={4}>
                                    <div >
                                        <Item elevation={0} sx={{ height: '5rem', position: 'relative' }}>
                                            <div className='card' style={{ border:'none',justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', width: '14.2rem', position: 'absolute', left: '0rem', bottom: '0.3rem', }}>
                                                <div style={{ padding: '0.4rem', borderRadius: '50%', backgroundColor: 'lightgreen' }}>
                                                    <FaCheckCircle style={{ position: 'relative', color: 'green', fontSize: 22 }} />
                                                </div>
                                                <div>
                                                    <Typography color='green' style={{ fontWeight: 'bold' }}>{ContactMadeStatus}</Typography>
                                                    <Typography style={{ fontSize: 15 }}>Contact-Made Lead Status</Typography>
                                                </div>
                                            </div>
                                        </Item>
                                    </div>
                                </Grid>
                                <Grid style={{ height: '8rem', marginBottom: '0.8rem' }} item xs={4}>
                                    <div >
                                        <Item elevation={0} sx={{ height: '5rem', position: 'relative' }}>
                                            <div className='card' style={{ border:'none',justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', width: '13.3rem', position: 'absolute', left: '0rem', bottom: '0.3rem', }}>
                                                <div style={{ padding: '0.4rem', borderRadius: '50%', backgroundColor: 'lightgreen' }}>
                                                    <FaCheckCircle style={{ position: 'relative', color: 'green', fontSize: 22 }} />
                                                </div>
                                                <div>
                                                    <Typography color='green' style={{ fontWeight: 'bold' }}>{followedStatus}</Typography>
                                                    <Typography style={{ fontSize: 15 }}>FollowedUp Lead Status</Typography>
                                                </div>
                                            </div>
                                        </Item>
                                    </div>
                                </Grid>
                                <Grid style={{ height: '8rem', marginBottom: '0.8rem' }} item xs={4}>
                                    <div >
                                        <Item elevation={0} sx={{ height: '5rem', position: 'relative' }}>
                                            <div className='card' style={{ border:'none',justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', width: '10.2rem', position: 'absolute', left: '0rem', bottom: '0.3rem', }}>
                                                <div style={{ padding: '0.4rem', borderRadius: '50%', backgroundColor: 'lightgreen' }}>
                                                    <FaCheckCircle style={{ position: 'relative', color: 'green', fontSize: 22 }} />
                                                </div>
                                                <div>
                                                    <Typography color='green' style={{ fontWeight: 'bold' }}>{newStatus}</Typography>
                                                    <Typography style={{ fontSize: 15 }}>New Lead Status</Typography>
                                                </div>
                                            </div>
                                        </Item>
                                    </div>
                                </Grid>
                            </Grid>
                        </Item>
                    </div>
                </Grid>
            </Grid> */}
        </Box>
    )

}


export default TopCard